import type { Translations } from '../../../types'

const profileSessionsMessages: Translations = {
  "profile.sessions.title": "Sessioni e dispositivi",
  "profile.sessions.subtitle": "Controlla i device collegati al tuo account.",
  "profile.sessions.refresh": "Aggiorna",
  "profile.sessions.refreshing": "Aggiornamento...",
  "profile.sessions.stats.active": "Sessioni attive",
  "profile.sessions.stats.trusted": "Sessioni fidate",
  "profile.sessions.stats.stale": "Sessioni stale",
  "profile.sessions.lastAccess": "Ultimo accesso:",
  "profile.sessions.registeredIp": "IP registrato:",
  "profile.sessions.location": "Posizione:",
  "profile.sessions.currentSection.title": "Sessione corrente",
  "profile.sessions.currentSection.subtitle": "Questa sessione resta attiva su questo dispositivo.",
  "profile.sessions.otherSection.title": "Altre sessioni attive",
  "profile.sessions.otherSection.subtitle": "Sessioni attive su altri browser o dispositivi.",
  "profile.sessions.otherSection.empty": "Nessun'altra sessione attiva.",
  "profile.sessions.table.device": "Dispositivo",
  "profile.sessions.table.ip": "IP / Località",
  "profile.sessions.table.lastActivity": "Ultima attività",
  "profile.sessions.table.status": "Stato",
  "profile.sessions.table.actions": "Azioni",
  "profile.sessions.createdLabel": "Creata",
  "profile.sessions.status.current": "Sessione attuale",
  "profile.sessions.status.trusted": "Fidata",
  "profile.sessions.status.untrusted": "Richiede conferma",
  "profile.sessions.status.stale": "Stale",
  "profile.sessions.markTrusted": "Segna fidato",
  "profile.sessions.markTrusted.loading": "...",
  "profile.sessions.revoke": "Revoca",
  "profile.sessions.revoke.loading": "Revoca...",
  "profile.sessions.revokeSelected": "Revoca selezionate",
  "profile.sessions.revokeSelected.loading": "Revoca selezionate...",
  "profile.sessions.revokeAllExceptCurrent": "Revoca tutte tranne la corrente",
  "profile.sessions.revokeAllExceptCurrent.loading": "Revoca in corso...",
  "profile.sessions.selectMode.enable": "Selezione multipla",
  "profile.sessions.selectMode.cancel": "Annulla selezione",
  "profile.sessions.selectMode.selectAll": "Seleziona tutte le sessioni revocabili",
  "profile.sessions.selectMode.selectRow": "Seleziona sessione",
  "profile.sessions.loading": "Caricamento sessioni...",
  "profile.sessions.empty": "Nessun dispositivo registrato.",
  "profile.sessions.unknownUserAgent": "User agent sconosciuto",
  "profile.sessions.createdAt": "Creato {{date}}",
  "profile.sessions.logoutNotice": "Sessione corrente terminata, effettua di nuovo il login.",
}

export default profileSessionsMessages
